<template>
  <div class="available-balance-card flex column align-center justify-center">
    <p v-if="isVehicleSelected" class="value flex">{{ value }}</p>
    <p v-if="isVehicleSelected" class="label flex">{{ label }}</p>
    <p v-else class="label flex">Vehículo no seleccionado</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AvailableBalanceCard',
  props: {
    vehicleId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['vehicles']),
    isVehicleSelected: function () {
      return this.vehicleId > 0
    },
    selectedVehicle: function () {
      if (this.isVehicleSelected) {
        return this.vehicles.find(vehicle => vehicle.id === this.vehicleId)
      }

      return undefined
    },
    label: function () {
      const vehicle = this.selectedVehicle

      if (!vehicle) return ''

      return vehicle.contract_type === 'Saldo' ? 'SALDO DISPONIBLE' : 'FECHA DE EXPIRACIÓN'
    },
    value: function () {
      const vehicle = this.selectedVehicle

      if (!this.selectedVehicle) return ''

      return vehicle.contract_type === 'Saldo' ? vehicle.formatted_balance : vehicle.formatted_expiration_date
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.available-balance-card {
  background-color: $purple;
  border-radius: 2rem;
  color: $white;
  width: 18%;
  height: 11rem;
}

.value {
  font-size: 2rem;
}

.label {
  font-size: 1rem;
  font-weight: 600;
  max-width: 90%;
}

@media(max-width: 90rem) {
  .available-balance-card {
    height: 12rem;
  }

  .value {
    font-size: 2rem;
  }

  .label {
    font-size: 1rem;
  }
}

@media screen and (max-width: 480px) {
  .available-balance-card{
    width: 100%;
    margin-bottom: 6%;
  }
}
</style>
